export default __webpack_public_path__ + "static/media/10-100.97d0cd55.png";